import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles, tags, categories } from '@/mocks/articles';

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat?.name || slug;
}

export default function TagPage() {
  const { slug } = useParams<{ slug: string }>();
  const tag = tags.find((t) => t.slug === slug);
  const tagArticles = articles.filter((a) => a.tags.includes(slug || ''));

  if (!tag) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen pt-20 flex items-center justify-center bg-background-50">
          <div className="text-center">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
              <i className="ri-price-tag-3-line text-foreground-400 text-5xl"></i>
            </div>
            <h1 className="text-2xl font-bold text-foreground-950 mb-2">标签未找到</h1>
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      <section className="w-full pt-20 pb-10 bg-background-50">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 text-center py-14">
          <div className="inline-flex items-center gap-2 border border-primary-500/40 rounded-full px-4 py-1.5 mb-5">
            <span className="text-primary-500 text-xs font-semibold">标签</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-foreground-950 font-heading mb-3">
            #{tag.name}
          </h1>
          <p className="text-foreground-600 text-sm">
            共 {tagArticles.length} 篇相关爆料
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {tags.map((t) => (
              <Link
                key={t.id}
                to={`/tag/${t.slug}`}
                className={`text-xs px-3 py-1.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  t.slug === slug
                    ? 'bg-primary-500 text-background-50 font-semibold'
                    : 'bg-background-200 text-foreground-600 hover:bg-background-300'
                }`}
              >
                {t.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-14">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          {tagArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {tagArticles.map((article) => (
                <ArticleCard
                  key={article.id}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  category={article.category}
                  categoryName={getCategoryName(article.category)}
                  publishDate={article.publishDate}
                  imageUrl={article.imageUrl}
                  isHot={article.isHot}
                  isExclusive={article.isExclusive}
                  viewCount={article.viewCount}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-inbox-line text-foreground-400 text-4xl"></i>
              </div>
              <p className="text-foreground-600">该标签下暂无内容</p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
}